function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaeTool({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 510.004 510.004",
    style: {
      enableBackground: "new 0 0 510.004 510.004"
    },
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1135_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#CCCCCC",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    d: "M366.202,323.77L186.229,143.796 c15.979-33.453,10.121-74.732-17.587-102.44S99.656,7.789,66.203,23.769l49.406,49.407l-42.427,42.426L23.776,66.196 C7.796,99.649,13.654,140.927,41.363,168.635c27.708,27.708,68.986,33.566,102.439,17.587l179.973,179.975 c-15.979,33.453-10.121,74.732,17.587,102.44c27.708,27.708,68.986,33.566,102.439,17.587l-49.406-49.406l42.427-42.427 l49.406,49.407c15.98-33.453,10.121-74.732-17.587-102.44C440.934,313.649,399.655,307.79,366.202,323.77z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1136_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1137_",
    style: {
      fill: "none",
      stroke: "#CCCCCC",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    d: "M191.367,233.79 l-158.79,158.78c-11.71,11.721-17.57,27.07-17.57,42.431c0,15.36,5.86,30.71,17.57,42.43c23.439,23.431,61.419,23.431,84.86,0 l158.779-158.79"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#CCCCCC",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    x1: 202.614,
    y1: 307.395,
    x2: 64.401,
    y2: 445.608
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_1138_",
    style: {
      fill: "none",
      stroke: "#CCCCCC",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    points: "255.006,212.57  360.002,107.572 370.612,52.002 462.002,18.001 492.002,48.001 457.998,139.391 402.432,150.001 297.436,255.001 \t\t"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaeTool);
export default __webpack_public_path__ + "static/media/CAETool.736c02d7203c0c4a340b3a0a96d445a6.svg";
export { ForwardRef as ReactComponent };